import {
  DocumentData,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  setDoc,
  where,
} from 'firebase/firestore'
import { makeAutoObservable } from 'mobx'
import { db } from '../api/firebase'
import { store } from './store'
import { NotificationType } from '../models/Notification'

type NewType = DocumentData

export default class NotificationsStore {
  notifications: NotificationType[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setNotifications = (state: NotificationType[]) => {
    this.notifications = state
  }

  countNotifications = () =>
    this.notifications.reduce(
      (count: number, notif: NotificationType) => count + (notif.read ? 0 : 1),
      0,
    )

  handleMarkNotification = async (notification: NotificationType) => {
    await setDoc(doc(db, 'notifications', notification.id), {
      ...notification,
      read: !notification.read,
    })
  }

  handleDeleteNotification = async (id: string) => {
    await deleteDoc(doc(db, 'notifications', id))
  }

  handleMarkAllAsRead = () => {
    const unreadNotifications = this.notifications.filter((notification) => !notification.read)

    unreadNotifications.forEach(async (notification) => {
      await setDoc(doc(db, 'notifications', notification.id), {
        ...notification,
        read: true,
      })
    })
  }

  getNotifications = () => {
    const { user } = store.userStore
    if (user) {
      const notificationCollectionRef = query(
        collection(db, 'notifications'),
        where('userId', '==', user?.id),
      )

      onSnapshot(notificationCollectionRef, (snapshot: NewType) => {
        this.setNotifications(snapshot.docs.map((doc: any) => ({ id: doc.id, ...doc.data() })))
      })
    }
  }
}
